'use strict';
(function() {
	angular.module('onboarding.services')
		.factory('subjectObserverMessagesService', subjectObserverMessagesService);

	function subjectObserverMessagesService() {
		var OBSERVER_NAME_PRE = 'COB_OBSERVER_';
		var SUBJECT_NAME_PRE = 'COB_SUBJECT_';
		var OBSERVER_MESSAGE_PRE = 'cob:observer:';
		var SUBJECT_MESSAGE_PRE = 'cob:subject:';

		var MESSAGES = {
			CARRIER_LIST_EXPAND: 'carrierListExpand',
			LOGIN_STARTING: 'loginStarting',
			LOGIN_FINISHED_SUCCESS: 'loginFinishedSuccess',
			LOGIN_FINISHED_FAIL: 'loginFinishedFail',
			SESSION_RESUME: 'sessionResume',
			FILE_UPLOAD_SAVED: 'fileUploadSaved',
			FILE_UPLOAD_SUCCESS: 'fileUploadSuccess',
			FILE_UPLOAD_ERROR: 'fileUploadError',
			FORM_VALIDATION_ERROR: 'formValidationError',
			CONTRACT_GROUP_SELECTED: 'contractGroupSelected',
			SETTINGS_BROKER_OPEN: 'settingsBrokerOpen',
			SETTINGS_BROKER_CLOSE: 'settingsBrokerClose',
			PROFILE_CARRIER_OPEN: 'profileCarrierOpen',
			PROFILE_CARRIER_CLOSE: 'profileCarrierClose',
			PROFILE_SETTINGS_DIRTY: 'profileSettingsDirty',
			PROFILE_SETTINGS_CLEAN: 'profileSettingsClean',
			PROFILE_SETTINGS_CHANGE_VIEW: 'profileSettingsChangeView',
			PROFILE_SETTINGS_SAVE_VIEW: 'profileSettingsSaveView',
			SCROLL_MESSAGE: 'scrollMessage',
			VIEW_CHANGE: 'viewChange',
			AJAX_WAITING: 'ajaxWaiting',
			AJAX_DONE: 'ajaxDone',
			DOMAIN_DATA_LOADED: 'domainDataLoaded',
			CHANGE_WELCOME_VIEW: 'changeWelcomeView',
			START_CHANGE_CARRIER_PROFILE_VIEW: 'startChangeCarrierProfileView',
			FINISH_CHANGE_CARRIER_PROFILE_VIEW: 'finishChangeCarrierProfileView',
			CARRIER_PROFILE_VIEW_IS_DIRTY: 'carrierProfileViewIsDirty',
			CARRIER_PROFILE_VIEW_LOAD: 'carrierProfileViewLoad',
			CARRIER_PROFILE_W8_LOADED: 'carrierProfileW8Loaded',
			CARRIER_PROFILE_W9_LOADED: 'carrierProfileW9Loaded',
			CARRIER_PROFILE_TAX_RELOAD: 'carrierProfileTaxReload',
			CARRIER_PROFILE_INSUREANCE_DOB_LOADED: 'carrierProfileInsuranceDobLoaded',
			CARRIER_PROFILE_INSUREANCE_REG_LOADED: 'carrierProfileInsuranceRegLoaded',
			CARRIER_PROFILE_INSUREANCE_RELOAD: 'carrierProfileInsuranceReload',
			CARRIER_PROFILE_VIEW_STATUS: 'carrierProfileViewStatus',
			CARRIER_PROFILE_READY_TO_SIGN: 'carrierProfileReadyToSign',
			SET_PENDING_TAB: 'setPendingCarrierProfileViewChange',
			CARRIER_PROFILE_STATUS_FINISH: 'profileStatusLookupFinish',
			LOAD_CHATSUPPORT: 'loadLiveChatSupport',
			CARRIER_SCROLL : 'carrierScroll',
			HTTP_ERROR_401: 'browserError401',
			HTTP_ERROR_404: 'browserError404',
			HTTP_ERROR_500: 'browserError500',
			CAROUSEL_REQUEST_OPEN: 'carouselRequestOpen'
		};
		var observerMessages = {};
		var subjectMessages = {};
		var observerMessageLookup = {};

		buildMessages();

		return {
			getObserverMessages: getObserverMessages,
			getSubjectMessages: getSubjectMessages,
			getObserverMessageLookup: getObserverMessageLookup
		};

		function getObserverMessageLookup() {
			return observerMessageLookup;
		}

		function getObserverMessages() {
			return observerMessages;
		}

		function getSubjectMessages() {
			return subjectMessages;
		}

		function buildMessages() {
			for (var message in MESSAGES) {
				if (Object.prototype.hasOwnProperty.call(MESSAGES, message)) {
					var observerMessage = OBSERVER_NAME_PRE + message;
					var subjectMessage = SUBJECT_NAME_PRE + message;
					observerMessages[observerMessage] = OBSERVER_MESSAGE_PRE + MESSAGES[message];
					subjectMessages[subjectMessage] = SUBJECT_MESSAGE_PRE + MESSAGES[message];

					observerMessageLookup[subjectMessages[subjectMessage]] = observerMessages[observerMessage];
				}
			}
		}
	}
})();
